export const DATE_FORMATS = {
    UI_DESKTOP: 'dd MMM yyyy',
    UI_MOBILE: 'EEE d MMM yyyy',
    ISO_DATE: 'yyyy-MM-dd',
    ISO_DATE_TIME: 'yyyy-MM-ddTHH:mm:ss',
    DATE_DD_MM_YYYY: 'dd/MM/yyyy'
} as const;
